const API_URL = process.env.REACT_APP_API_URL || '';

export const buildImageUrl = (src) => {
  if (!src) return '/placeholder.jpg';
  if (/^(https?:|blob:|data:)/i.test(src)) return src;
  return `${API_URL}${src.startsWith('/') ? '' : '/'}${src}`;
};

/**
 * Centralized image URL optimizer.
 * - Adds responsive width and quality parameters for Cloudinary.
 * - Requests WebP for API/CDN images that support query transformations.
 * - Preserves object URLs, data URLs, placeholders, and bundled app assets.
 */
export const optimizeImage = (url, { width = 800, quality = 80 } = {}) => {
  if (!url) return url;

  const src = buildImageUrl(url);

  // ✨ Robust Validation: Safely catch logo, favicon, or layout assets anywhere in the URL string
  if (
    src.includes('placeholder.') ||
    src.includes('via.placeholder.com') ||
    /^(blob:|data:)/i.test(src) ||
    src.includes('/static/') ||
    src.includes('favicon') || 
    src.includes('logo')
  ) {
    return src;
  }

  // Cloudinary Dynamic Engine Rules
  if (src.includes('res.cloudinary.com') && src.includes('/upload/')) {
    return src.replace('/upload/', `/upload/f_auto,q_${quality},w_${width}/`);
  }

  // Generic CDN Fallback Query Rules
  const separator = src.includes('?') ? '&' : '?';
  return `${src}${separator}format=webp&width=${width}&quality=${quality}`;
};